(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naky-article"]) return;
  try {
    
  (function () {
    function slug(text) {
      var s = String(text).toLowerCase();
      if (s.normalize) { s = s.normalize('NFKD').replace(/[̀-ͯ]/g, ''); }
      s = s.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      return s || 'section';
    }
    function topInset() {
      var p = document.createElement('div');
      p.style.cssText = 'position:fixed;top:0;left:0;width:0;visibility:hidden;padding-top:env(safe-area-inset-top, 0px)';
      document.body.appendChild(p);
      var v = parseFloat(getComputedStyle(p).paddingTop) || 0;
      p.remove();
      return v;
    }
    function setup(root) {
      if (root.__nakyArticle) { return; }
      root.__nakyArticle = true;
      var body = root.querySelector('[data-naky-article-body]');
      if (!body) { return; }
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

      // 1. A paragraph that is entirely em (or i) reads secondary; the copy is not touched.
      Array.prototype.forEach.call(body.querySelectorAll('p'), function (p) {
        var kids = Array.prototype.filter.call(p.childNodes, function (n) { return !(n.nodeType === 3 && !/\S/.test(n.nodeValue)); });
        if (kids.length === 1 && kids[0].nodeType === 1 && (kids[0].tagName === 'EM' || kids[0].tagName === 'I')) { p.classList.add('naky-article__aside'); }
      });

      // 2. Every h2 gets an id from its text (a numeric suffix on duplicates and on ids already in
      //    the document); an id the content carries is kept.
      var heads = Array.prototype.slice.call(body.querySelectorAll('h2'));
      var used = {};
      heads.forEach(function (h) {
        if (!h.id) {
          var base = slug(h.textContent), id = base, n = 2;
          while (used[id] || document.getElementById(id)) { id = base + '-' + n; n++; }
          h.id = id;
        }
        used[h.id] = true;
      });

      // 3. The rail, one item per h2, only with three or more.
      var rail = root.querySelector('[data-naky-article-rail]');
      var list = root.querySelector('[data-naky-article-rail-list]');
      if (!rail || !list || heads.length < 3) { if (rail) { rail.hidden = true; } return; }
      heads.forEach(function (h) {
        var li = document.createElement('li');
        li.className = 'naky-article__rail-li';
        var a = document.createElement('a');
        a.className = 'naky-article__rail-item';
        a.href = '#' + h.id;
        a.setAttribute('data-target', h.id);
        var dot = document.createElement('span');
        dot.className = 'naky-article__rail-dot';
        dot.setAttribute('aria-hidden', 'true');
        var txt = document.createElement('span');
        txt.className = 'naky-article__rail-text';
        txt.textContent = h.textContent.replace(/\s+/g, ' ').trim();
        a.appendChild(dot);
        a.appendChild(txt);
        li.appendChild(a);
        list.appendChild(li);
      });
      rail.hidden = false;
      var links = Array.prototype.slice.call(list.querySelectorAll('.naky-article__rail-item'));

      // 4. The legal rail's behaviour: the active item is the last h2 whose top has reached its
      //    landing line (its scroll-margin-top, the bar + 24), picked by an observer and by a
      //    passive scroll listener captured from whichever element scrolls (.page-wrapper at 990
      //    and up, the document below); smooth click; a hash on load lands under the bar.
      var active = null;
      var lockUntil = 0;
      function setActive(id) {
        if (!id || id === active) { return; }
        active = id;
        links.forEach(function (a) {
          var on = a.getAttribute('data-target') === id;
          a.classList.toggle('is-active', on);
          if (on) { a.setAttribute('aria-current', 'true'); } else { a.removeAttribute('aria-current'); }
        });
      }
      function pick() {
        if (performance.now() < lockUntil) { return; }
        var line = (parseFloat(getComputedStyle(heads[0]).scrollMarginTop) || 0) + 1;
        var id = heads[0].id;
        for (var i = 0; i < heads.length; i++) {
          if (heads[i].getBoundingClientRect().top <= line) { id = heads[i].id; } else { break; }
        }
        setActive(id);
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function () { pick(); }, { rootMargin: '-' + (120 + topInset()) + 'px 0px -55% 0px' });
        Array.prototype.forEach.call(body.children, function (el) { io.observe(el); });
      }
      var queued = false;
      document.addEventListener('scroll', function () {
        if (queued) { return; }
        queued = true;
        requestAnimationFrame(function () { queued = false; pick(); });
      }, { capture: true, passive: true });
      setActive(heads[0].id);
      links.forEach(function (a) {
        a.addEventListener('click', function (e) {
          if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { return; }
          var id = a.getAttribute('data-target');
          var target = document.getElementById(id);
          if (!target) { return; }
          e.preventDefault();
          lockUntil = performance.now() + (reduce.matches ? 0 : 900);
          setActive(id);
          target.scrollIntoView({ behavior: reduce.matches ? 'instant' : 'smooth', block: 'start' });
          if (history.replaceState) { history.replaceState(null, '', '#' + id); }
          setTimeout(pick, 950);
        });
      });
      var h = '';
      try { h = decodeURIComponent((location.hash || '').slice(1)); } catch (err) { h = ''; }
      if (h) {
        var t = document.getElementById(h);
        if (t && body.contains(t)) { t.scrollIntoView({ behavior: 'instant', block: 'start' }); requestAnimationFrame(pick); }
      }
    }
    function init() { Array.prototype.forEach.call(document.querySelectorAll('[data-naky-article]'), setup); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naky-bmi"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // BMI = kg / m^2, computed from pounds and inches with the EXACT conversion factor
    // 0.45359237 / 0.0254^2 = 703.0696. The spec writes the familiar rounded constant 703,
    // but its own acceptance case (5'6", 180 lb -> 29.1) only holds with the exact factor:
    // 703 gives 29.0496, which displays 29.0. Swap this one constant back to 703 if Mike
    // rules for the rounded formula.
    var FACTOR = 703.0696;
    var DUR = 800;        // numeral count and marker travel, in sync
    var PANEL_DUR = 250;  // panel expand, after the marker settles
    var MIN = 14, MAX = 40;

    function category(b) {
      if (b < 18.5) { return 'under'; }
      if (b < 25) { return 'healthy'; }
      if (b < 30) { return 'over'; }
      return 'obese';
    }
    // Piecewise EQUAL QUARTERS, so each category owns a quarter of the arc no matter how
    // wide its BMI band is.
    function toT(b) {
      b = Math.max(MIN, Math.min(MAX, b));
      if (b < 18.5) { return (b - 14) / 4.5 * 0.25; }
      if (b < 25) { return 0.25 + (b - 18.5) / 6.5 * 0.25; }
      if (b < 30) { return 0.5 + (b - 25) / 5 * 0.25; }
      return 0.75 + (b - 30) / 10 * 0.25;
    }
    function easeOut(x) { return 1 - Math.pow(1 - x, 3); }
    function reduced() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function wire(root) {
      var form = root.querySelector('[data-bmi-form]');
      if (!form) { return; }
      var ft = root.querySelector('[data-bmi-ft]');
      var inch = root.querySelector('[data-bmi-in]');
      var lb = root.querySelector('[data-bmi-lb]');
      var err = root.querySelector('[data-bmi-error]');
      var live = root.querySelector('[data-bmi-live]');
      var arc = root.querySelector('[data-bmi-arc]');
      var marker = root.querySelector('[data-bmi-marker]');
      var numeral = root.querySelector('[data-bmi-numeral]');
      var rows = root.querySelectorAll('.naky-bmi__row');
      var errorCopy = root.getAttribute('data-bmi-error-copy') || '';
      var current = null;   // last displayed BMI, the start of the next animation
      var raf = null;
      var panelTimer = null;

      function placeMarker(b) {
        var R = arc.offsetWidth / 2;
        var card = getComputedStyle(root.querySelector('.naky-bmi__card'));
        var ring = parseFloat(card.getPropertyValue('--bmi-ring')) || 0;
        var r = parseFloat(card.getPropertyValue('--bmi-apex')) || (R - ring); // the APEX radius
        var a = -Math.PI + toT(b) * Math.PI; // -pi at the left end, 0 at the right
        var x = R + r * Math.cos(a);
        var y = R + r * Math.sin(a);
        var deg = (a - Math.PI / 2) * 180 / Math.PI; // apex toward the centre, base outward
        // The box's top-centre IS the apex and the rotation origin (50% 0), so placing it at
        // (x, y) lands the apex there at any angle.
        marker.style.left = x + 'px';
        marker.style.top = y + 'px';
        marker.style.transform = 'translate(-50%, 0) rotate(' + deg + 'deg)';
      }
      function show(b) {
        numeral.textContent = b.toFixed(1);
        placeMarker(b);
      }
      function collapseAll(except) {
        for (var i = 0; i < rows.length; i++) {
          if (rows[i] === except) { continue; }
          rows[i].classList.remove('is-active', 'naky-card--stop-1');
          var p = rows[i].querySelector('[data-bmi-panel]');
          p.hidden = true;
          p.style.height = '';
          p.style.transition = '';
        }
      }
      function openRow(row, instant) {
        var p = row.querySelector('[data-bmi-panel]');
        if (row.classList.contains('is-active') && !p.hidden) { return; }
        // The panel ground is the SHARED science-card stop-1 gradient, applied by its own
        // class from the token layer rather than re-declared here.
        row.classList.add('is-active', 'naky-card--stop-1');
        p.hidden = false;
        if (instant) { p.style.height = ''; return; }
        var h = p.scrollHeight;
        p.style.height = '0px';
        void p.offsetHeight;
        p.style.transition = 'height ' + PANEL_DUR + 'ms ease-out';
        p.style.height = h + 'px';
        setTimeout(function () { p.style.height = ''; p.style.transition = ''; }, PANEL_DUR + 20);
      }
      function rowFor(cat) {
        for (var i = 0; i < rows.length; i++) {
          if (rows[i].getAttribute('data-cat') === cat) { return rows[i]; }
        }
        return null;
      }

      function fail() {
        if (raf) { cancelAnimationFrame(raf); raf = null; }
        if (panelTimer) { clearTimeout(panelTimer); panelTimer = null; }
        collapseAll(null);
        marker.hidden = true;
        numeral.textContent = '';
        live.textContent = '';
        current = null;
        err.textContent = errorCopy;
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var f = parseFloat(ft.value);
        var i = inch.value === '' ? 0 : parseFloat(inch.value);
        var w = parseFloat(lb.value);
        var total = f * 12 + i;
        if (!isFinite(f) || !isFinite(i) || !isFinite(w) || i < 0 || i >= 12 ||
            total < 36 || total > 96 || w < 50 || w > 700) {
          fail();
          return;
        }
        err.textContent = '';
        var target = FACTOR * w / (total * total);
        var cat = category(target);       // on the UNROUNDED value
        var row = rowFor(cat);
        var shown = target.toFixed(1);
        var announce = 'Your BMI is ' + shown + ', ' + (row ? row.getAttribute('data-say') : '') + '.';

        if (raf) { cancelAnimationFrame(raf); raf = null; }
        if (panelTimer) { clearTimeout(panelTimer); panelTimer = null; }
        marker.hidden = false;

        if (reduced()) {
          show(target);
          collapseAll(row);
          if (row) { openRow(row, true); }
          current = target;
          live.textContent = announce;
          return;
        }

        // A recalculation animates from the previous state; the first one starts at the
        // left end of the scale.
        var from = current === null ? MIN : current;
        if (!(row && row.classList.contains('is-active'))) { collapseAll(null); }
        var t0 = null;
        function step(ts) {
          if (t0 === null) { t0 = ts; }
          var k = Math.min(1, (ts - t0) / DUR);
          var b = from + (target - from) * easeOut(k);
          show(b);
          if (k < 1) { raf = requestAnimationFrame(step); return; }
          raf = null;
          show(target);
          current = target;
          live.textContent = announce;
          if (row) { openRow(row, false); }
        }
        raf = requestAnimationFrame(step);
      });

      // Breakpoints change the arc size, so a shown marker is re-placed on resize.
      window.addEventListener('resize', function () {
        if (current !== null && !marker.hidden) { placeMarker(current); }
      });
    }

    function init() {
      var roots = document.querySelectorAll('[data-naky-bmi]');
      for (var i = 0; i < roots.length; i++) {
        if (roots[i].getAttribute('data-bmi-on') === '1') { continue; }
        roots[i].setAttribute('data-bmi-on', '1');
        wire(roots[i]);
      }
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
    else { init(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naky-buy-box"] && !Shopify.designMode) return;
  try {
    
  // Gallery: one select() drives every input (thumb, arrow, swipe) so state can never fork.
  // Buttons everywhere, so Enter/Space come free from the UA's own click synthesis and
  // there is no custom key handling here to get wrong.
  (function () {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var mobile = window.matchMedia('(max-width: 749px)');

    document.querySelectorAll('.naky-buy__gallery').forEach(function (gallery) {
      var images = Array.prototype.slice.call(gallery.querySelectorAll('.naky-buy__hero-img'));
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.naky-buy__thumb-btn'));
      var arrows = Array.prototype.slice.call(gallery.querySelectorAll('.naky-buy__arrow'));
      var stage = gallery.querySelector('.naky-buy__hero');
      if (images.length < 2) { return; }
      var current = 0;

      function select(index) {
        var wrapped = ((index % images.length) + images.length) % images.length;
        images.forEach(function (image) {
          var on = image.getAttribute('data-naky-media') === String(wrapped);
          // Dropping loading="lazy" is what guarantees the fetch has started: keep it even
          // though in-flow slides now intersect the viewport on their own.
          if (on) { image.removeAttribute('loading'); }
          image.classList.toggle('is-selected', on);
        });
        thumbs.forEach(function (thumb) {
          var on = thumb.getAttribute('data-naky-media') === String(wrapped);
          thumb.setAttribute('aria-pressed', on ? 'true' : 'false');
          // block: 'nearest' is load-bearing. Without it this scrolls the PAGE vertically
          // to the thumb strip on every swap.
          if (on && thumb.scrollIntoView) {
            thumb.scrollIntoView({
              inline: 'nearest',
              block: 'nearest',
              behavior: reduced.matches ? 'auto' : 'smooth'
            });
          }
        });
        current = wrapped;
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          select(parseInt(thumb.getAttribute('data-naky-media'), 10));
        });
      });

      arrows.forEach(function (arrow) {
        arrow.addEventListener('click', function () {
          select(current + parseInt(arrow.getAttribute('data-naky-step'), 10));
        });
      });

      // Mobile swipe. The gesture is only claimed once horizontal intent is clear, and the
      // stage carries touch-action: pan-y, so vertical scrolling stays with the browser.
      if (stage) {
        var startX = 0, startY = 0, tracking = false, horizontal = false;
        stage.addEventListener('pointerdown', function (event) {
          if (!mobile.matches) { return; }
          tracking = true;
          horizontal = false;
          startX = event.clientX;
          startY = event.clientY;
        });
        stage.addEventListener('pointermove', function (event) {
          if (!tracking) { return; }
          var dx = event.clientX - startX;
          var dy = event.clientY - startY;
          if (!horizontal && Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) { horizontal = true; }
          if (!horizontal && Math.abs(dy) > 10) { tracking = false; }
        });
        stage.addEventListener('pointerup', function (event) {
          if (!tracking) { return; }
          tracking = false;
          if (!horizontal) { return; }
          var dx = event.clientX - startX;
          if (dx <= -40) { select(current + 1); }
          else if (dx >= 40) { select(current - 1); }
        });
        stage.addEventListener('pointercancel', function () { tracking = false; });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naky-collection-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // The element that actually scrolls the stories block: Pitch scrolls .page-wrapper at
    // desktop and the document at mobile, so it is found, never assumed.
    function scrollerFor(el) {
      for (var p = el.parentElement; p && p !== document.body && p !== document.documentElement; p = p.parentElement) {
        var oy = getComputedStyle(p).overflowY;
        if ((oy === 'auto' || oy === 'scroll') && p.scrollHeight > p.clientHeight) { return p; }
      }
      return document.scrollingElement || document.documentElement;
    }
    // Once TrustBox injects its iframe, focus and the a11y tree belong to the anchor alone.
    // The observer stays connected, so a re-rendered iframe is tamed too.
    function tame(link) {
      var f = link.querySelector('iframe');
      if (f && f.getAttribute('tabindex') !== '-1') {
        f.setAttribute('tabindex', '-1');
        f.setAttribute('aria-hidden', 'true');
      }
    }
    function init(link) {
      if (link.hasAttribute('data-naky-jump-ready')) { return; }
      link.setAttribute('data-naky-jump-ready', '');
      tame(link);
      new MutationObserver(function () { tame(link); }).observe(link, { childList: true, subtree: true });
      link.addEventListener('click', function (e) {
        if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { return; }
        var target = document.querySelector('.naky-stories');
        if (!target) { return; } // no stories block: keep the outbound default
        e.preventDefault();
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        // The bar's own bottom edge (the nav-height token is a calc since 22.6, so it is measured)
        var bar = document.querySelector('.naky-nav__bar');
        var nav = bar ? bar.getBoundingClientRect().bottom : 0;
        var sc = scrollerFor(target);
        var isDoc = sc === document.scrollingElement || sc === document.documentElement;
        var top = sc.scrollTop + target.getBoundingClientRect().top - (isDoc ? 0 : sc.getBoundingClientRect().top) - nav;
        try { sc.scrollTo({ top: top, behavior: reduce ? 'instant' : 'smooth' }); }
        catch (err) { sc.scrollTop = top; }
      });
    }
    function boot() { document.querySelectorAll('[data-naky-stories-jump]').forEach(init); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naky-help"]) return;
  try {
    
  (function () {
    function setup(root) {
      if (root.__nakyHelp) { return; }
      root.__nakyHelp = true;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      var topics = Array.prototype.slice.call(root.querySelectorAll('.naky-help__topic'));
      var links = Array.prototype.slice.call(root.querySelectorAll('.naky-help__rail-item, .naky-help__chip'));
      var chipRow = root.querySelector('.naky-help__chips');
      var active = null;
      var lockUntil = 0;

      function keepChipInView(chip) {
        if (!chipRow || !chip || chipRow.scrollWidth <= chipRow.clientWidth) { return; }
        var left = chip.offsetLeft - 24;
        var right = chip.offsetLeft + chip.offsetWidth + 24 - chipRow.clientWidth;
        var target = null;
        if (chipRow.scrollLeft > left) { target = left; }
        else if (chipRow.scrollLeft < right) { target = right; }
        if (target !== null) { chipRow.scrollTo({ left: Math.max(0, target), behavior: reduce.matches ? 'instant' : 'smooth' }); }
      }
      function setActive(id) {
        if (!id || id === active) { return; }
        active = id;
        links.forEach(function (a) {
          var on = a.getAttribute('data-topic') === id;
          a.classList.toggle('is-active', on);
          if (on) { a.setAttribute('aria-current', 'true'); } else { a.removeAttribute('aria-current'); }
          if (on && a.classList.contains('naky-help__chip')) { keepChipInView(a); }
        });
      }

      // The active topic follows scroll: the first topic crossing a band that starts just
      // under the sticky offsets (112 desktop, 124 mobile) and ends at 45% of the viewport.
      // The band follows the bar's bottom edge: 120, plus the safe-area top inset (0 in Mobile
      // Safari and on desktop), read from a probe because env() has no script API.
      function topInset() {
        var p = document.createElement('div');
        p.style.cssText = 'position:fixed;top:0;left:0;width:0;visibility:hidden;padding-top:env(safe-area-inset-top, 0px)';
        document.body.appendChild(p);
        var v = parseFloat(getComputedStyle(p).paddingTop) || 0;
        p.remove();
        return v;
      }
      var seen = {};
      function pick() {
        if (performance.now() < lockUntil) { return; }
        for (var i = 0; i < topics.length; i++) {
          if (!topics[i].hidden && seen[topics[i].id]) { setActive(topics[i].id); return; }
        }
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { seen[e.target.id] = e.isIntersecting; });
          pick();
        }, { rootMargin: '-' + (120 + topInset()) + 'px 0px -55% 0px' });
        topics.forEach(function (t) { io.observe(t); });
      }
      if (topics.length) { setActive(topics[0].id); }

      // A rail item or a chip scrolls to its topic (scroll-margin-top lands it under the
      // sticky offset); smooth, or instant under reduced motion.
      links.forEach(function (a) {
        a.addEventListener('click', function (e) {
          if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { return; }
          var id = a.getAttribute('data-topic');
          var target = document.getElementById(id);
          if (!target) { return; }
          e.preventDefault();
          lockUntil = performance.now() + (reduce.matches ? 0 : 900);
          setActive(id);
          target.scrollIntoView({ behavior: reduce.matches ? 'instant' : 'smooth', block: 'start' });
          if (history.replaceState) { history.replaceState(null, '', '#' + id); }
          setTimeout(pick, 950);
        });
      });

      // A hash that names a DRAWER (spec §23.13) opens it and seats it under the sticky offset
      // (its scroll-margin-top, as the topics'); the observer above then marks its topic. A hash
      // that names a topic is left to the browser, exactly as before.
      function openFromHash(smooth) {
        var id = '';
        try { id = decodeURIComponent((location.hash || '').slice(1)); } catch (err) { return; }
        var row = id ? document.getElementById(id) : null;
        if (!row || !root.contains(row) || !row.classList.contains('naky-help__row') || row.hidden) { return; }
        row.open = true;
        row.scrollIntoView({ behavior: smooth && !reduce.matches ? 'smooth' : 'instant', block: 'start' });
      }
      openFromHash(false);
      window.addEventListener('hashchange', function () { openFromHash(true); });

      // Search: hide the drawers that do not contain the query (case-insensitive, question
      // or answer), then the topics left empty with their rail item and chip; a no-match line
      // under the hero; clearing restores everything. No network.
      var input = root.querySelector('[data-naky-help-search]');
      var nomatch = root.querySelector('[data-naky-help-nomatch]');
      if (input) {
        var rows = Array.prototype.slice.call(root.querySelectorAll('.naky-help__row'));
        input.addEventListener('input', function () {
          var raw = input.value.trim();
          var q = raw.toLowerCase();
          var shown = 0;
          rows.forEach(function (r) {
            var hit = !q || r.textContent.toLowerCase().indexOf(q) !== -1;
            r.hidden = !hit;
            if (hit) { shown++; }
          });
          topics.forEach(function (t) {
            var empty = !!q && !t.querySelector('.naky-help__row:not([hidden])');
            t.hidden = empty;
            Array.prototype.forEach.call(root.querySelectorAll('[data-topic="' + t.id + '"]'), function (el) {
              if (el !== t && (el.classList.contains('naky-help__rail-li') || el.classList.contains('naky-help__chip-item'))) { el.hidden = empty; }
            });
          });
          if (nomatch) {
            if (q && shown === 0) { nomatch.textContent = 'No matches for “' + raw + '”.'; nomatch.hidden = false; }
            else { nomatch.hidden = true; nomatch.textContent = ''; }
          }
          var first = topics.filter(function (t) { return !t.hidden; })[0];
          if (first && (!active || document.getElementById(active).hidden)) { active = null; setActive(first.id); }
          // the chip row's scroll width changed: let the swipe indicator recompute
          window.dispatchEvent(new Event('resize'));
        });
      }
    }
    function init() { Array.prototype.forEach.call(document.querySelectorAll('[data-naky-help]'), setup); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naky-how-it-works"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var sections = document.querySelectorAll('.naky-hiw');
      for (var i = 0; i < sections.length; i++) {
        var el = sections[i];
        if (el.getAttribute('data-tracker') === 'on') continue;
        el.setAttribute('data-tracker', 'on');
        // Leave the completed default in place when we cannot animate cleanly, or when
        // the section is already reachable on load (winding it back would flash).
        if (reduce || !('IntersectionObserver' in window)) continue;
        if (el.getBoundingClientRect().top <= window.innerHeight) continue;
        el.classList.add('naky-hiw--pre');
        (function (node) {
          var io = new IntersectionObserver(function (entries) {
            for (var j = 0; j < entries.length; j++) {
              if (entries[j].isIntersecting) {
                node.classList.remove('naky-hiw--pre');
                io.disconnect();
                return;
              }
            }
          }, { threshold: 0.4 });
          io.observe(node);
        })(el);
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naky-journey"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var sections = document.querySelectorAll('.naky-journey');
      for (var i = 0; i < sections.length; i++) {
        var el = sections[i];
        if (el.getAttribute('data-motion') === 'on') continue;
        el.setAttribute('data-motion', 'on');
        if (reduce || !('IntersectionObserver' in window)) continue;
        if (el.getBoundingClientRect().top <= window.innerHeight) continue;
        el.classList.add('naky-journey--pre');
        (function (node) {
          var io = new IntersectionObserver(function (entries) {
            for (var j = 0; j < entries.length; j++) {
              if (entries[j].isIntersecting) {
                node.classList.remove('naky-journey--pre');
                io.disconnect();
                return;
              }
            }
          }, { threshold: 0.4 });
          io.observe(node);
        })(el);
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naky-legal"]) return;
  try {
    
  (function () {
    // The run-in label (§24.12): a leading Title Case run of at most 80 characters ending in the
    // colon, with no sentence punctuation and no line separator inside it, so a lead-in sentence
    // ("Do not use the Wegovy® Pill if:") is body text and "Boxed Warning:" is a label.
    var LABEL = /^(\s*)([A-Z][^:.;!?\n\u2028\u2029]{0,78}:)/;
    var MINOR = ['of', 'and', 'or', 'with', 'for', 'the', 'a', 'an', 'in', 'to', 'on', 'by'];
    function titleCase(s) {
      var words = s.split(/\s+/);
      for (var i = 0; i < words.length; i++) {
        var w = words[i].replace(/^[^A-Za-z0-9\u00C0-\u024F]+/, '');
        if (!w) { continue; }
        var c = w.charAt(0);
        if (c !== c.toLowerCase() || /[0-9]/.test(c) || MINOR.indexOf(w) !== -1) { continue; }
        return false;
      }
      return true;
    }
    function isBr(n) { return n && n.nodeType === 1 && n.tagName === 'BR'; }
    // An empty span, or one holding only no-break spaces (§24.18: the policies' br runs), is blank.
    function isEmptySpan(n) {
      return n.nodeType === 1 && n.tagName === 'SPAN' && !n.querySelector('*') && /^\u00a0*$/.test(n.textContent);
    }
    function isBlank(n) {
      if (!n) { return false; }
      if (n.nodeType === 3) { return !/\S/.test(n.nodeValue); }
      return isEmptySpan(n);
    }
    // A <br> followed (past blank text and empty spans) by another <br> starts a paragraph break.
    function breakAfter(br) {
      var n = br.nextSibling;
      while (n && isBlank(n)) { n = n.nextSibling; }
      return isBr(n) ? n : null;
    }
    function splitRuns(body) {
      Array.prototype.slice.call(body.children).forEach(function (p) {
        if (p.tagName !== 'P') { return; }
        var cur = p;
        var kids = Array.prototype.slice.call(cur.childNodes);
        for (var i = 0; i < kids.length; i++) {
          var k = kids[i];
          if (!isBr(k) || k.parentNode !== cur) { continue; }
          var last = k, next;
          while ((next = breakAfter(last))) { last = next; }
          if (last === k) { continue; }
          var np = document.createElement('p');
          var after = last.nextSibling;
          // remove the br run (and the blanks between), move the rest into the new paragraph
          var n = k;
          while (n && n !== after) { var nn = n.nextSibling; cur.removeChild(n); n = nn; }
          while (after) { var a = after.nextSibling; np.appendChild(after); after = a; }
          cur.parentNode.insertBefore(np, cur.nextSibling);
          cur = np;
          kids = Array.prototype.slice.call(cur.childNodes); i = -1;
        }
      });
    }
    function dropEmptySpans(body) {
      Array.prototype.slice.call(body.querySelectorAll('span')).forEach(function (s) {
        if (isEmptySpan(s)) { s.parentNode.removeChild(s); }
      });
    }
    // §24.19: no-break spaces at a paragraph's edges are trimmed (whitespace, not copy). CSS drops
    // ordinary spaces at a line's start and end but renders a no-break space, which indented
    // "\u00a0Your Rights and Acknowledgements:" on the Terms; regular spaces are left as they are.
    function trimNbspEdges(p) {
      var nodes = [], w = document.createTreeWalker(p, NodeFilter.SHOW_TEXT, null), t, i, run;
      while ((t = w.nextNode())) { nodes.push(t); }
      for (i = 0; i < nodes.length; i++) {
        run = /^\s*/.exec(nodes[i].nodeValue)[0];
        var rest = nodes[i].nodeValue.slice(run.length);
        if (run.indexOf('\u00a0') !== -1) { nodes[i].nodeValue = run.replace(/\u00a0/g, '') + rest; }
        if (rest.length) { break; }
      }
      for (i = nodes.length - 1; i >= 0; i--) {
        run = /\s*$/.exec(nodes[i].nodeValue)[0];
        var keep = nodes[i].nodeValue.slice(0, nodes[i].nodeValue.length - run.length);
        if (run.indexOf('\u00a0') !== -1) { nodes[i].nodeValue = keep + run.replace(/\u00a0/g, ''); }
        if (keep.length) { break; }
      }
    }
    function firstText(el) {
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var t;
      while ((t = w.nextNode())) { if (/\S/.test(t.nodeValue)) { return t; } }
      return null;
    }
    // Wraps the run-in label in strong.naky-legal__label and returns the label without its colon.
    function markLabel(p) {
      var t = firstText(p);
      if (!t) { return null; }
      var m = LABEL.exec(t.nodeValue);
      if (!m) { return null; }
      var lead = m[1], text = m[2], par = t.parentNode;
      if (!titleCase(text.slice(0, -1))) { return null; }
      if (par !== p && (par.tagName === 'STRONG' || par.tagName === 'B') && par.textContent.trim() === text.trim()) {
        par.classList.add('naky-legal__label');
      } else {
        t.splitText(lead.length + text.length);
        var lab = t;
        if (lead.length) { lab = t.splitText(lead.length); }
        var strong = document.createElement('strong');
        strong.className = 'naky-legal__label';
        lab.parentNode.insertBefore(strong, lab);
        strong.appendChild(lab);
      }
      var label = text.replace(/:\s*$/, '').trim();
      if (p.textContent.trim() === text.trim()) { p.classList.add('naky-legal__group'); }
      return label;
    }
    // An all-caps paragraph (§24.12): every letter upper case, at most 80 characters, no terminal
    // period ("USES AND DISCLOSURES OF PHI") is a group heading as well; a rail entry may name it.
    function capsHeading(p) {
      var t = p.textContent.replace(/\s+/g, ' ').trim();
      if (!t || t.length > 80 || /\.$/.test(t) || !/[A-Z]/.test(t) || t !== t.toUpperCase()) { return null; }
      p.classList.add('naky-legal__group');
      return t;
    }
    // The child nodes that count for a paragraph's edges: whitespace-only text and meta are ignored.
    function sig(p) {
      return Array.prototype.filter.call(p.childNodes, function (n) {
        return !(n.nodeType === 3 && !/\S/.test(n.nodeValue)) && !(n.nodeType === 1 && n.tagName === 'META');
      });
    }
    // §24.14: a br that is the first or last child of a paragraph is dropped (no blank first line).
    function edgeBrs(p) {
      var k = sig(p);
      while (k.length && (isBr(k[0]) || isBr(k[k.length - 1]))) {
        p.removeChild(isBr(k[0]) ? k[0] : k[k.length - 1]);
        k = sig(p);
      }
    }
    // §24.14 HEADING LINE: a run alone on its line (between the paragraph's edges and its brs) that
    // is Title Case with the colon optional ("Drug Interactions", "Warnings and Precautions:",
    // "Boxed Warning: Risk of Thyroid C-Cell Tumors"), at most 80 characters, no sentence
    // punctuation, no line separator. §24.16: a colon label whose text after the colon carries a
    // digit or a comma is a label with a value, not a heading ("Effective Date: November 11, 2025").
    function headingLine(raw) {
      if (/[\u2028\u2029]/.test(raw)) { return null; }
      var t = raw.replace(/\s+/g, ' ').trim();
      if (!t || t.length > 80 || !/^[A-Z]/.test(t) || /[.;!?]/.test(t) || !titleCase(t.replace(/:/g, ' '))) { return null; }
      var c = t.indexOf(':');
      if (c !== -1 && /[0-9,]/.test(t.slice(c + 1))) { return null; }
      return t;
    }
    // The policy variant's heading line (§24.18): an all-caps line (at most 80 characters, no
    // terminal period) or an enumerated sub-head ("1. Information You Provide to Us"); a Title
    // Case line alone is not one there ("Naky Health LLC" in an address block).
    function policyHeading(raw) {
      if (/[\u2028\u2029]/.test(raw)) { return null; }
      var t = raw.replace(/\s+/g, ' ').trim();
      if (!t || t.length > 80 || /\.$/.test(t)) { return null; }
      if (/[A-Z]/.test(t) && t === t.toUpperCase()) { return t; }
      var m = /^\d{1,2}\.\s+(.+)$/.exec(t);
      if (m && /^[A-Z]/.test(m[1]) && !/[.;!?]/.test(m[1]) && titleCase(m[1].replace(/:/g, ' '))) { return t; }
      return null;
    }
    function visible(nodes) {
      return nodes.some(function (n) { return n.nodeType === 1 ? (n.tagName !== 'BR' && n.tagName !== 'META') : /\S/.test(n.nodeValue); });
    }
    // Splits a paragraph at its heading lines: each heading line becomes its own paragraph (the br
    // around it becomes the paragraph boundary); the lines between headings stay together, with
    // their brs. A paragraph that is one heading line is left as it is and only recorded.
    function splitHeadings(p, heads, test) {
      var segs = [[]];
      Array.prototype.slice.call(p.childNodes).forEach(function (n) {
        if (isBr(n)) { var s = []; s.br = n; segs.push(s); } else { segs[segs.length - 1].push(n); }
      });
      var groups = [];
      segs.forEach(function (s) {
        if (test(s.map(function (n) { return n.textContent; }).join(''))) { groups.push({ nodes: s.slice(), head: true }); return; }
        var last = groups[groups.length - 1];
        if (last && !last.head) { if (s.br) { last.nodes.push(s.br); } Array.prototype.push.apply(last.nodes, s); }
        else { groups.push({ nodes: s.slice(), head: false }); }
      });
      if (!groups.some(function (g) { return g.head; })) { return; }
      if (groups.length === 1) { heads.push(p); return; }
      // a group with nothing visible (meta only) rides with the next group, or the last one
      var kept = [];
      groups.forEach(function (g, i) {
        if (visible(g.nodes) || g.head) { kept.push(g); return; }
        if (i + 1 < groups.length) { groups[i + 1].nodes = g.nodes.concat(groups[i + 1].nodes); }
        else if (kept.length) { kept[kept.length - 1].nodes = kept[kept.length - 1].nodes.concat(g.nodes); }
      });
      while (p.firstChild) { p.removeChild(p.firstChild); }
      var cur = p;
      kept.forEach(function (g, i) {
        var el = i === 0 ? p : document.createElement('p');
        g.nodes.forEach(function (n) { el.appendChild(n); });
        if (i > 0) { cur.parentNode.insertBefore(el, cur.nextSibling); cur = el; }
        if (g.head) { heads.push(el); }
      });
    }
    function topInset() {
      var p = document.createElement('div');
      p.style.cssText = 'position:fixed;top:0;left:0;width:0;visibility:hidden;padding-top:env(safe-area-inset-top, 0px)';
      document.body.appendChild(p);
      var v = parseFloat(getComputedStyle(p).paddingTop) || 0;
      p.remove();
      return v;
    }

    function setup(root) {
      if (root.__nakyLegal) { return; }
      root.__nakyLegal = true;
      var policy = root.hasAttribute('data-naky-legal-policy');
      var body = root.querySelector('[data-naky-legal-body]');
      if (!body && policy) {
        body = root.querySelector('.shopify-policy__body .rte');
        if (body) { body.classList.add('naky-legal__body'); body.setAttribute('data-naky-legal-body', ''); }
      }
      if (!body) { return; }
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      var rail = root.querySelector('[data-naky-legal-rail]');
      var band = root.querySelector('[data-naky-legal-band]');
      var chipRow = root.querySelector('[data-naky-legal-chips]');

      // 1. The content: paragraph breaks, empty spans, run-in labels and group headings.
      splitRuns(body);
      dropEmptySpans(body);
      var heads = [];
      Array.prototype.slice.call(body.children).forEach(function (el) {
        if (el.tagName !== 'P') { return; }
        edgeBrs(el);
        splitHeadings(el, heads, policy ? policyHeading : headingLine);
      });
      // Policy variant: a first paragraph reading "Last updated <date>" (with or without a
      // terminal period) leaves the column and becomes the updated line under the title, as on
      // the legal pages, without the period (Mike's ruling, §24.18).
      if (policy) {
        var first = body.firstElementChild;
        var lu = first && first.tagName === 'P' ? /^Last updated\s+(.+?)\.?$/.exec(first.textContent.replace(/\s+/g, ' ').trim()) : null;
        if (lu && /^[A-Z][a-z]+ \d{1,2}, \d{4}$/.test(lu[1])) {
          var line = document.createElement('p');
          line.className = 'naky-legal__updated';
          line.textContent = 'Last updated ' + lu[1];
          var title = root.querySelector('.shopify-policy__title');
          if (title) { title.parentNode.insertBefore(line, title.nextSibling); first.parentNode.removeChild(first); }
        }
      }
      Array.prototype.slice.call(body.children).forEach(function (el) { if (el.tagName === 'P') { trimNbspEdges(el); } });
      // A paragraph is a rail target under its run-in label, its all-caps text, or (a heading line)
      // its text without a trailing colon; a heading line takes the group treatment.
      var paras = [];
      Array.prototype.slice.call(body.children).forEach(function (el) {
        if (el.tagName !== 'P') { return; }
        var keys = [];
        var label = markLabel(el) || capsHeading(el);
        if (label) { keys.push(label); }
        if (heads.indexOf(el) !== -1) {
          el.classList.add('naky-legal__group');
          var t = el.textContent.replace(/\s+/g, ' ').trim().replace(/:$/, '');
          if (keys.indexOf(t) === -1) { keys.push(t); }
        }
        if (keys.length) { paras.push({ el: el, keys: keys }); }
      });
      function paraFor(label) {
        var key = label.toLowerCase();
        for (var i = 0; i < paras.length; i++) {
          for (var j = 0; j < paras[i].keys.length; j++) { if (paras[i].keys[j].toLowerCase() === key) { return paras[i]; } }
        }
        return null;
      }

      // 2. The rail targets: the metafield's items matched to the labels (an item with no match
      //    drops out); no metafield, no rail (Liquid renders none).
      var targets = [];
      Array.prototype.slice.call(root.querySelectorAll('.naky-legal__rail-item')).forEach(function (a) {
        var id = a.getAttribute('data-target');
        var pr = paraFor(a.getAttribute('data-label') || '');
        if (!pr) {
          Array.prototype.forEach.call(root.querySelectorAll('[data-target="' + id + '"]'), function (el) {
            var li = el.closest('li'); if (li && li.parentNode) { li.parentNode.removeChild(li); }
          });
          return;
        }
        if (!pr.el.id) { pr.el.id = id; }
        targets.push({ id: pr.el.id, el: pr.el });
      });
      // the chips follow the rail's order and drops; a chip whose target never resolved goes too
      if (chipRow) {
        Array.prototype.slice.call(chipRow.querySelectorAll('.naky-legal__chip')).forEach(function (c) {
          var ok = targets.some(function (t) { return t.id === c.getAttribute('data-target'); });
          if (!ok) { var li = c.closest('li'); if (li) { li.parentNode.removeChild(li); } }
        });
      }
      targets.sort(function (a, b) { return a.el.compareDocumentPosition(b.el) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1; });
      var show = targets.length >= 3;
      if (rail) { rail.hidden = !show; }
      if (band) { band.hidden = !show; }
      if (!show) { return; }
      // the chip row's width is now known: let the swipe indicator recompute
      window.dispatchEvent(new Event('resize'));

      // 3. The Help Center's behaviour, lifted: active follows scroll, smooth click, the hash.
      var links = Array.prototype.slice.call(root.querySelectorAll('.naky-legal__rail-item, .naky-legal__chip'));
      var active = null;
      var lockUntil = 0;
      function keepChipInView(chip) {
        if (!chipRow || !chip || chipRow.scrollWidth <= chipRow.clientWidth) { return; }
        var left = chip.offsetLeft - 24;
        var right = chip.offsetLeft + chip.offsetWidth + 24 - chipRow.clientWidth;
        var target = null;
        if (chipRow.scrollLeft > left) { target = left; }
        else if (chipRow.scrollLeft < right) { target = right; }
        if (target !== null) { chipRow.scrollTo({ left: Math.max(0, target), behavior: reduce.matches ? 'instant' : 'smooth' }); }
      }
      function setActive(id) {
        if (!id || id === active) { return; }
        active = id;
        links.forEach(function (a) {
          var on = a.getAttribute('data-target') === id;
          a.classList.toggle('is-active', on);
          if (on) { a.setAttribute('aria-current', 'true'); } else { a.removeAttribute('aria-current'); }
          if (on && a.classList.contains('naky-legal__chip')) { keepChipInView(a); }
        });
      }
      // The active item is the last target whose top has reached its own landing line (its
      // scroll-margin-top: the bar + 24, or + 92 under the chips band), so a paragraph is active
      // from the moment a click would land it. Paragraphs are not wrapping sections, hence the
      // line rather than the Help Center's first intersecting topic; the band's observer alone
      // fires only as a paragraph enters or leaves the band, so a passive scroll listener (one
      // pick per frame, captured from whichever element scrolls: .page-wrapper at 990 and up,
      // the document below) runs it as well.
      function pick() {
        if (performance.now() < lockUntil) { return; }
        var line = (parseFloat(getComputedStyle(targets[0].el).scrollMarginTop) || 0) + 1;
        var id = targets[0].id;
        for (var i = 0; i < targets.length; i++) {
          if (targets[i].el.getBoundingClientRect().top <= line) { id = targets[i].id; } else { break; }
        }
        setActive(id);
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function () { pick(); }, { rootMargin: '-' + (120 + topInset()) + 'px 0px -55% 0px' });
        Array.prototype.forEach.call(body.children, function (el) { io.observe(el); });
      }
      var queued = false;
      document.addEventListener('scroll', function () {
        if (queued) { return; }
        queued = true;
        requestAnimationFrame(function () { queued = false; pick(); });
      }, { capture: true, passive: true });
      setActive(targets[0].id);
      links.forEach(function (a) {
        a.addEventListener('click', function (e) {
          if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { return; }
          var id = a.getAttribute('data-target');
          var target = document.getElementById(id);
          if (!target) { return; }
          e.preventDefault();
          lockUntil = performance.now() + (reduce.matches ? 0 : 900);
          setActive(id);
          target.scrollIntoView({ behavior: reduce.matches ? 'instant' : 'smooth', block: 'start' });
          if (history.replaceState) { history.replaceState(null, '', '#' + id); }
          setTimeout(pick, 950);
        });
      });
      // A hash on load lands under the sticky offset (the ids exist only from here on).
      var h = '';
      try { h = decodeURIComponent((location.hash || '').slice(1)); } catch (err) { h = ''; }
      if (h) {
        var t = document.getElementById(h);
        if (t && body.contains(t)) { t.scrollIntoView({ behavior: 'instant', block: 'start' }); requestAnimationFrame(pick); }
      }
    }
    function init() { Array.prototype.forEach.call(document.querySelectorAll('[data-naky-legal]'), setup); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naky-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Two-way state toggle. State B (solid cream) is the CSS default so no-JS, and any
    // page without a hero, stay legible. This only ADDS State A while the nav overlaps
    // the hero. Sentinel is an IntersectionObserver on the hero whose root is inset by
    // the nav's own bottom edge, so the flip happens exactly when the nav clears the
    // hero, with no scroll listener and therefore no jitter at the boundary.
    function wire(nav) {
      var hero = document.querySelector('.naky-hero');
      var bar = nav.querySelector('.naky-nav__bar');
      // No hero (PDP, collections, any non-homepage template) means State B always. The
      // inline head script only guesses State A on the homepage, but clear it here too so
      // a mis-guess can never persist.
      if (!hero || !bar || !('IntersectionObserver' in window)) {
        document.documentElement.classList.remove('naky-nav-top');
        return null;
      }
      var navBottom = Math.round(bar.getBoundingClientRect().bottom);
      // set the initial state synchronously, so the cream default is not shown at top
      if (hero.getBoundingClientRect().bottom > navBottom) {
        document.documentElement.classList.add('naky-nav-top');
      } else {
        document.documentElement.classList.remove('naky-nav-top');
      }
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            document.documentElement.classList.add('naky-nav-top');
          } else {
            document.documentElement.classList.remove('naky-nav-top');
          }
        }
      }, { rootMargin: '-' + navBottom + 'px 0px 0px 0px', threshold: 0 });
      io.observe(hero);
      return io;
    }

    function init() {
      var navs = document.querySelectorAll('.naky-nav');
      for (var i = 0; i < navs.length; i++) {
        var nav = navs[i];
        if (nav.getAttribute('data-nav-state') === 'on') { continue; }
        nav.setAttribute('data-nav-state', 'on');
        (function (node) {
          var io = wire(node);
          // The nav's bottom edge differs per breakpoint (88 desktop, 56 mobile), and
          // rootMargin is fixed at construction, so rebuild the sentinel when the
          // breakpoint changes. Not a scroll listener.
          if (window.matchMedia) {
            var mq = window.matchMedia('(max-width: 749px)');
            var relink = function () { if (io) { io.disconnect(); } io = wire(node); };
            if (mq.addEventListener) { mq.addEventListener('change', relink); }
            else if (mq.addListener) { mq.addListener(relink); }
          }
        })(nav);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  (function () {
    // DESKTOP MEGA PANELS (§19.3). CLICK toggles (mouse and touch alike; hover does
    // nothing), another trigger swaps, the same trigger, an outside click or Escape close,
    // and Escape returns focus to the trigger. Enter arrives as the anchor's own click;
    // Space is handled here. One panel at a time, through ONE writer, so no input can fork
    // the state. The anchors keep their collection hrefs: with no JS they simply navigate,
    // and a modified click (new tab, new window) still does.
    function isDesktop() {
      return window.matchMedia ? window.matchMedia('(min-width: 750px)').matches : true;
    }

    function setup(nav) {
      var bar = nav.querySelector('.naky-nav__bar');
      var items = Array.prototype.slice.call(nav.querySelectorAll('.naky-nav__link-item[data-naky-mp]'));
      if (!bar || !items.length) { return; }
      var openItem = null;

      // The li stays the positioning context, so the panel is centred on the BAR here.
      function place(item) {
        var panel = item.querySelector('.naky-nav__mp');
        if (!panel) { return; }
        var br = bar.getBoundingClientRect();
        var ir = item.getBoundingClientRect();
        panel.style.left = (br.left + (br.width - panel.offsetWidth) / 2 - ir.left) + 'px';
      }
      function placeAll() { items.forEach(place); }

      function apply(item, focusBack) {
        var was = openItem;
        items.forEach(function (it) {
          var on = it === item;
          it.setAttribute('data-open', on ? 'true' : 'false');
          var t = it.querySelector('.naky-nav__link');
          if (t) { t.setAttribute('aria-expanded', on ? 'true' : 'false'); }
        });
        openItem = item;
        // The shipped solid-bar state: cream while any panel is open, back on close.
        if (item) { nav.classList.add('naky-nav--panel-open'); place(item); }
        else { nav.classList.remove('naky-nav--panel-open'); }
        if (!item && focusBack && was) {
          var trig = was.querySelector('.naky-nav__link');
          if (trig) { trig.focus(); }
        }
      }

      items.forEach(function (item) {
        var trigger = item.querySelector('.naky-nav__link');
        if (!trigger) { return; }
        trigger.addEventListener('click', function (e) {
          if (!isDesktop()) { return; }
          if (e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { return; }
          e.preventDefault();
          apply(openItem === item ? null : item);
        });
        trigger.addEventListener('keydown', function (e) {
          if (!isDesktop()) { return; }
          if (e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            apply(openItem === item ? null : item);
          }
        });
      });

      document.addEventListener('click', function (e) {
        if (openItem && !openItem.contains(e.target)) { apply(null); }
      });
      document.addEventListener('keydown', function (e) {
        if (openItem && (e.key === 'Escape' || e.key === 'Esc')) {
          e.preventDefault();
          apply(null, true);
        }
      });
      // Focus that leaves the nav altogether (Tab past its last stop) closes the panel, so
      // it can never sit over the element that now has focus. Moving between the bar's own
      // stops keeps it open.
      nav.addEventListener('focusout', function (e) {
        if (openItem && e.relatedTarget && !nav.contains(e.relatedTarget)) { apply(null); }
      });
      window.addEventListener('resize', function () {
        if (!isDesktop()) { if (openItem) { apply(null); } return; }
        placeAll();
      });
      placeAll();
      if (document.fonts && document.fonts.ready) { document.fonts.ready.then(placeAll); }
    }

    function init() {
      var navs = document.querySelectorAll('.naky-nav');
      for (var i = 0; i < navs.length; i++) {
        if (navs[i].getAttribute('data-nav-mp') === 'on') { continue; }
        navs[i].setAttribute('data-nav-mp', 'on');
        setup(navs[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  (function () {
    // MOBILE SHEET (§19.4). Exclusive accordions; each time the sheet opens, the page's own
    // program opens instantly (data-initial) and the rest close, so nothing persists across
    // close and reopen. The body scroll locks while the sheet is open and releases on close.
    // With no JS the native details drawer still opens; the accordions stay closed.
    function setup(nav) {
      var drawer = nav.querySelector('.naky-nav__drawer');
      if (!drawer) { return; }
      var accs = Array.prototype.slice.call(drawer.querySelectorAll('.naky-nav__acc'));
      var root = document.documentElement;

      function set(acc, on) {
        acc.setAttribute('data-open', on ? 'true' : 'false');
        var t = acc.querySelector('.naky-nav__acc-trigger');
        if (t) { t.setAttribute('aria-expanded', on ? 'true' : 'false'); }
      }
      function only(target) { accs.forEach(function (a) { set(a, a === target); }); }

      accs.forEach(function (acc) {
        var t = acc.querySelector('.naky-nav__acc-trigger');
        if (!t) { return; }
        t.addEventListener('click', function () {
          only(acc.getAttribute('data-open') === 'true' ? null : acc);
        });
      });

      drawer.addEventListener('toggle', function () {
        if (drawer.open) {
          drawer.classList.add('naky-nav__drawer--instant');
          var first = null;
          accs.forEach(function (a) { if (!first && a.hasAttribute('data-initial')) { first = a; } });
          only(first);
          void drawer.offsetHeight; // commit the state with transitions off
          drawer.classList.remove('naky-nav__drawer--instant');
          root.classList.add('naky-nav-locked');
        } else {
          root.classList.remove('naky-nav-locked');
        }
      });

      // The sheet is mobile only: crossing to desktop closes it, which also releases the lock.
      if (window.matchMedia) {
        var mq = window.matchMedia('(min-width: 750px)');
        var shut = function () { if (mq.matches && drawer.open) { drawer.open = false; } };
        if (mq.addEventListener) { mq.addEventListener('change', shut); }
        else if (mq.addListener) { mq.addListener(shut); }
      }
    }

    function init() {
      var navs = document.querySelectorAll('.naky-nav');
      for (var i = 0; i < navs.length; i++) {
        if (navs[i].getAttribute('data-nav-sheet') === 'on') { continue; }
        navs[i].setAttribute('data-nav-sheet', 'on');
        setup(navs[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naky-router"]) return;
  try {
    
  (function () {
    // Never matched, whatever trigger_scope says (§20.1).
    var EXCLUDE = '.naky-nav, .naky-footer, .naky-shelf';
    var OUT_MS = 120;

    function setup(dialog) {
      if (dialog.__nakyRouter) { return; }
      dialog.__nakyRouter = true;
      var root = document.documentElement;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      var opener = null;
      var closing = null;
      var downOnScrim = false;

      var scope = dialog.getAttribute('data-trigger-scope') || '';
      var found = [];
      try { found = scope ? Array.prototype.slice.call(document.querySelectorAll(scope)) : []; } catch (e) { found = []; }
      var triggers = found.filter(function (a) {
        return a.tagName === 'A' && !a.closest(EXCLUDE) && !dialog.contains(a);
      });

      function open(from) {
        if (dialog.open) { return; }
        if (closing) { clearTimeout(closing); closing = null; }
        opener = from || null;
        dialog.showModal();
        root.classList.add('naky-router-locked');
        void dialog.offsetWidth; // commit the transparent start state before fading in
        dialog.setAttribute('data-shown', '');
        // Start on the title, not on the first control: showModal() focuses the close button,
        // and iOS WebKit paints its ring after a tap, which the frame does not draw (09/30).
        var title = dialog.querySelector('.naky-router__h2');
        if (title) { title.focus({ preventScroll: true }); }
      }
      function finish() {
        closing = null;
        if (dialog.open) { dialog.close(); }
      }
      function close() {
        if (!dialog.open || closing) { return; }
        dialog.removeAttribute('data-shown');
        if (reduce.matches) { finish(); } else { closing = setTimeout(finish, OUT_MS); }
      }

      // Every way out ends here, including a native close the cancel handler did not catch.
      dialog.addEventListener('close', function () {
        if (closing) { clearTimeout(closing); closing = null; }
        dialog.removeAttribute('data-shown');
        root.classList.remove('naky-router-locked');
        var o = opener;
        opener = null;
        if (o && document.contains(o)) { o.focus(); }
      });
      dialog.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
      var btn = dialog.querySelector('.naky-router__close');
      if (btn) { btn.addEventListener('click', close); }
      dialog.addEventListener('pointerdown', function (e) { downOnScrim = e.target === dialog; });
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog && downOnScrim) { close(); }
        downOnScrim = false;
      });

      triggers.forEach(function (a) {
        a.setAttribute('aria-haspopup', 'dialog');
        a.setAttribute('aria-controls', dialog.id);
        a.setAttribute('data-naky-router-opener', '');
        a.addEventListener('click', function (e) {
          if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { return; }
          e.preventDefault();
          open(a);
        });
      });
    }

    function init() {
      Array.prototype.forEach.call(document.querySelectorAll('dialog[data-naky-router]'), setup);
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
